import React, { useState } from 'react';
import { IconButton, Drawer, List, ListItem, ListItemText } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import useNavbarStyles from '../navbarStyles';
import AboutUsIcon from '../../../assets/images/about.svg';
import ViewerIcon from '../../../assets/images/viewer.svg';
import ProjectIcon from '../../../assets/images/project.svg';
import { useHandleClick } from '../../../utils/clickHandlers';

//Mobile responsive navbar (collapse the navbar into hamburger menu)
const MobileNavbar = ({ isScrolled }) => {
  const classes = useNavbarStyles();
  const handleClick = useHandleClick();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  return (
    <>
      {/* Hamburger Icon */}
      <IconButton
        edge="end"
        aria-label="menu"
        onClick={toggleDrawer(!drawerOpen)}
        disableRipple
        className={`${classes.hamburgerMenuIcon} ${isScrolled ? classes.iconDark : ''}`}
      >
        {drawerOpen ? (
          <CloseIcon
            className={`${classes.iconSize} ${isScrolled ? classes.iconDark : ''
            } ${classes.activeCloseIcon}`}
          />
        ) : (
          <MenuIcon
            className={`${classes.iconSize} ${
            isScrolled ? classes.iconDark : ''
            }`}
          />
        )}
      </IconButton>

      {/* Drawer Menu */}
      <Drawer
        anchor="top"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        classes={{ paper: classes.drawer }}
      >
        <div className={classes.drawerContent}>
          <List>
            <ListItem button onClick={(event) => { handleClick(event, 'project'); setDrawerOpen(false); }}>
              <img src={ProjectIcon} alt='About Project' className={classes.drawerIcon} />  
              <ListItemText primary="Paket Visions" className={classes.drawerItem} />
            </ListItem>
            <ListItem button onClick={(event) => { handleClick(event, 'viewerToggle'); setDrawerOpen(false); }}>
              <img src={ViewerIcon} alt='Model Viewer' className={classes.drawerIcon} />
              <ListItemText primary="Model Viewer" className={classes.drawerItem} />
            </ListItem>
            <ListItem button onClick={(event) => {handleClick(event, 'about-us'); setDrawerOpen(false);}}>
              <img src={AboutUsIcon} alt='About Us' className={classes.drawerIcon} />
              <ListItemText primary="About Us" className={classes.drawerItem} />
            </ListItem>
          </List>
        </div>
      </Drawer>
    </>
  );
};

export default MobileNavbar;